// extracted by mini-css-extract-plugin
module.exports = {"friend":"Friend_friend__3189K","avatar_container":"Friend_avatar_container__3gcK6","friend__name":"Friend_friend__name__vsZVq","avatar":"Friend_avatar__2xv2i"};